<dx-popup #popup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
    [showCloseButton]="true" title="Änderungsdetails" width="1300" height="auto"
    [maxWidth]="'95vw'" [maxHeight]="'90vh'" (onShown)="onPopupShown()" (onHidden)="onPopupHidden()">
    <div *dxTemplate="let data of 'content'">
      <dx-scroll-view height="100%" [useNative]="false" showScrollbar="onHover">
        <dx-data-grid #dataGrid class="changehistory-datagrid" [dataSource]="dataSource"
            [columnAutoWidth]="false" [wordWrapEnabled]="true" height="auto">
            <dxo-scrolling mode="standard" showScrollbar="onHover"></dxo-scrolling>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-sorting mode="none"></dxo-sorting>

            <dxi-column alignment="left" dataField="entityNameDisplay" caption="Entität" width="16%"></dxi-column>
            <dxi-column alignment="left" dataField="entityKeyDisplay" caption="Schlüssel" width="12%"></dxi-column>
            <dxi-column alignment="left" dataField="changeTypeDisplay" caption="Aktion" width="9%"></dxi-column>
            <dxi-column alignment="left" dataField="geaendertAm" caption="Änderungszeitpunkt" dataType="datetime"
                format="dd.MM.yyyy HH:mm" width="14%"></dxi-column>
            <dxi-column alignment="left" dataField="geaendertVon" caption="Benutzer" width="14%"></dxi-column>
            <dxi-column alignment="left" dataField="details" caption="Details" width="35%"></dxi-column>
        </dx-data-grid>
      </dx-scroll-view>
    </div>
    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ text: 'Schließen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onClickClose }">
    </dxi-popup-toolbar-item>
</dx-popup>
